export default "__VITE_ASSET__Ck_U3pO___"